import {ReplaySubject} from "rxjs";

export interface SystemStatusDTO {
    upgradeInProgress: boolean;
    features?: SystemFeaturesDTO;
}

export interface SystemFeaturesDTO {
    floorPlans: boolean
}

export class SystemStatus {
    public static shared: SystemStatus;
    public upgradeInProgress = false;
    public features = new SystemFeatures();
    private readonly changes = new ReplaySubject<SystemStatus>();
    public readonly changes$ = this.changes.asObservable();

    constructor() {
        if (SystemStatus.shared) {
            return SystemStatus.shared;
        }
        return SystemStatus.shared = this;
    }


    public update(systemStatus: SystemStatusDTO) {
        Object.assign(this, systemStatus);
        this.changes.next(this);
    }
}

export class SystemFeatures {
    public floorPlan = true;
}